/**
 * sell-product.js
 * Logic for selecting variants and updating prices on the Sell Product page.
 */

document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.sp-options-column');
  if (!container) return;

  const productData = JSON.parse(container.dataset.productJson || '{}');
  const swatches = document.querySelectorAll('.sp-swatch, .sp-condition-card');
  const priceDisplay = document.getElementById('PriceDisplay');
  const priceLoader = document.getElementById('PriceLoader');
  const priceNotice = document.getElementById('PriceNotice');
  const exactBtn = document.getElementById('ExactValueBtn');
  const timerEl = document.getElementById('PriceTimer');
  let selectedVariantId = null;
  let timerInterval = null;

  // Summary side panel elements
  const summaryCapacity = document.getElementById('SummaryCapacity');
  const summaryNetwork = document.getElementById('SummaryNetwork');
  const summaryCondition = document.getElementById('SummaryCondition');

  async function updateVariant(isInitial = false) {
    const selectedOptions = [];
    const activeValues = {};
    const totalOptionsCount = document.querySelectorAll('.sp-swatches-group').length;
    let selectedCount = 0;

    document.querySelectorAll('.sp-swatches-group').forEach((group, index) => {
      const activeEl = group.querySelector('.active');
      const optionName = group.dataset.optionName;

      if (activeEl) {
        const val = activeEl.dataset.value;
        selectedOptions[index] = val;
        activeValues[optionName] = val;
        selectedCount++;
      }
    });

    // Update Summary Panel Text
    if (summaryCapacity) summaryCapacity.textContent = activeValues['Capacity'] || activeValues['Storage'] || '';
    if (summaryNetwork) summaryNetwork.textContent = activeValues['Network'] || '';
    if (summaryCondition) summaryCondition.textContent = activeValues['Device Condition'] || activeValues['Condition'] || '';

    // Show "Please select..." if not all options are picked
    if (selectedCount < totalOptionsCount) {
      if (priceLoader) priceLoader.style.display = 'none';
      priceDisplay.textContent = '£0.00';
      priceDisplay.style.display = 'block';
      priceNotice.style.display = 'block';
      priceNotice.textContent = 'Please select options to get estimated value';
      if (timerEl) timerEl.style.display = 'none';
      selectedVariantId = null;
      return;
    }

    // Find matching variant
    const variant = productData.variants.find((v) => {
      return (
        (!selectedOptions[0] || v.option1 === selectedOptions[0]) &&
        (!selectedOptions[1] || v.option2 === selectedOptions[1]) &&
        (!selectedOptions[2] || v.option3 === selectedOptions[2])
      );
    });

    if (variant) {
      selectedVariantId = variant.id;
      // Set initial fallback price (Shopify)
      const fallbackPrice = (variant.price / 100).toLocaleString('en-GB', {
        style: 'currency',
        currency: 'GBP',
      });
      priceDisplay.textContent = fallbackPrice;
      priceDisplay.style.display = 'block';
      priceNotice.style.display = 'none';
      if (timerEl) {
        timerEl.style.display = 'flex';
        resetTimer();
      }

      // Update URL without reloading
      if (!isInitial) {
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set('variant', variant.id);
        window.history.replaceState({ path: newUrl.href }, '', newUrl.href);
      }

      if (exactBtn) {
        const url = new URL(exactBtn.href, window.location.origin);
        url.searchParams.set('variant', variant.id);
        exactBtn.href = url.toString();
      }

      // Fetch Buyback Price from API
      if (priceLoader && priceDisplay) {
        priceLoader.style.display = 'block';
        priceDisplay.style.display = 'none';
      }

      // Fetch Buyback Price from API
      try {
        const sku = variant.sku || '';
        const condition = activeValues['Device Condition'] || activeValues['Condition'] || 'excellent';
        const apiUrl = `https://qwikfoneapicall.azurewebsites.net/api/buyback_price?SKU=${sku}&type=GET`;

        const response = await fetch(apiUrl);
        const data = await response.json();

        if (data && data.length > 0) {
          const result = data[0];
          const conditionKey = `QwikFone buy back max price ${condition.toLowerCase()}`;
          const rawPrice = result[conditionKey];

          if (rawPrice !== undefined && rawPrice !== null) {
            const formattedPrice = parseFloat(rawPrice).toLocaleString('en-GB', {
              style: 'currency',
              currency: 'GBP',
            });
            priceDisplay.textContent = formattedPrice;
          }
        }
      } catch (error) {
        console.error('API Error:', error);
      } finally {
        if (priceLoader && priceDisplay) {
          priceLoader.style.display = 'none';
          priceDisplay.style.display = 'block';
        }
      }

    } else {
      if (priceLoader) priceLoader.style.display = 'none';
      priceDisplay.textContent = '£0.00';
      priceDisplay.style.display = 'block';
      priceNotice.style.display = 'block';
      priceNotice.textContent = 'Selection not available';
      selectedVariantId = null;
    }
  }

  // Handle Initial Load from URL
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get('variant');
  if (variantId) {
    const initialVariant = productData.variants.find(v => v.id.toString() === variantId);
    if (initialVariant) {
      // Select corresponding swatches
      const options = [initialVariant.option1, initialVariant.option2, initialVariant.option3];
      options.forEach((opt, idx) => {
        if (opt) {
          const group = document.querySelector(`.sp-swatches-group[data-option-index="${idx}"]`);
          if (group) {
            const swatch = group.querySelector(`[data-value="${opt}"]`);
            if (swatch) swatch.classList.add('active');
          }
        }
      });
    }
  }

  swatches.forEach((swatch) => {
    swatch.addEventListener('click', (e) => {
      const group = swatch.closest('.sp-swatches-group');
      group.querySelectorAll('.sp-swatch, .sp-condition-card').forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');
      updateVariant();
    });
  });

  // Handle "Get Exact Value" click: Add to cart then redirect
  if (exactBtn) {
    exactBtn.addEventListener('click', async (e) => {
      if (!selectedVariantId) {
        e.preventDefault();
        alert('Please select all options to continue.');
        return;
      }

      e.preventDefault();

      // Update button state
      const originalText = exactBtn.innerHTML;
      exactBtn.innerHTML = 'Processing...';
      exactBtn.classList.add('loading');
      exactBtn.style.pointerEvents = 'none';

      try {
        const variantObj = productData.variants.find(v => v.id === selectedVariantId);
        if (!variantObj) throw new Error('Variant not found');

        const capacity = summaryCapacity ? summaryCapacity.textContent : '';
        const name = productData.title.toLowerCase() + ' (' + capacity + ')';
        const variant = variantObj.id;
        const sku = variantObj.sku || '';
        const image = variantObj.featured_image ? variantObj.featured_image.src : (productData.featured_image || '');
        const price = priceDisplay ? priceDisplay.textContent : '';
        const network = summaryNetwork ? summaryNetwork.textContent : '';
        const condition = summaryCondition ? summaryCondition.textContent : '';
        const active = true;
        const url = window.location.href;

        // Optional: Clear cart first if this is a "sell" flow where only one item is allowed
        // await fetch('/cart/clear.js', { method: 'POST' });

        let cart = [];
        // Constructor
        function Item(name, variant, sku, image, capacity, network, condition, price, active, url) {
          this.name = name;
          this.variant = variant;
          this.sku = sku;
          this.image = image;
          this.capacity = capacity;
          this.network = network;
          this.condition = condition;
          this.price = price;
          this.active = active;
          this.url = url;
        }

        // Save cart
        function saveCart() {
          localStorage.removeItem('shoppingCartStorage');
          localStorage.setItem('shoppingCartStorage', JSON.stringify(cart));
        }

        const savedCart = localStorage.getItem('shoppingCartStorage') || localStorage.getItem('shoppingCart');
        if (savedCart) {
          try {
            cart = JSON.parse(savedCart);
          } catch (e) {
            cart = [];
          }
        }

        // Check for duplicates
        const isDuplicate = cart.some(item =>
          item.name === name &&
          item.variant === variant &&
          item.sku === sku &&
          item.price === price &&
          item.capacity === capacity &&
          item.network === network &&
          item.condition === condition
        );

        if (!isDuplicate) {
          const newItem = new Item(name, variant, sku, image, capacity, network, condition, price, active, url);
          cart.push(newItem);
          saveCart();
        }
      } catch (err) {
        console.error('Error adding to cart:', err);
      } finally {
        // Clear questionnaire session storage to ensure a fresh start
        sessionStorage.clear();

        // Always redirect even if cart add fails, though ideally it should work
        window.location.href = exactBtn.href;
      }
    });
  }

  // Timer logic
  function resetTimer() {
    if (timerInterval) clearInterval(timerInterval);
    const countdownEl = document.getElementById('TimerCountdown');
    if (!countdownEl) return;

    let timeLeft = 15 * 60; // 15 minutes

    const updateDisplay = (t) => {
      const mins = Math.floor(t / 60);
      const secs = t % 60;
      countdownEl.textContent = `${mins}m ${secs < 10 ? '0' : ''}${secs}s`;
    }

    // Initial update
    updateDisplay(timeLeft);

    timerInterval = setInterval(() => {
      timeLeft--;
      updateDisplay(timeLeft);

      if (timeLeft <= 0) {
        clearInterval(timerInterval);
        countdownEl.textContent = 'Expired';
      }
    }, 1000);
  }

  // Initial call
  updateVariant(true);
});
